<template>
    <div class="cs" :class="{ 'cs-active': isActive, 'cs-top': addressGray }" id="cs">
      <Category
        :path="'listen'"
        :category="category"
        :isActive="isActive"
        @handlerActive="onActive"
        @handlerUpdata="onUpdata"
        @handlerClear="onClear"
        v-if="category.length"
      ></Category>
      <Searches
        :pageIndex= "defParams.pageIndex"
        :searches="searches"
        :path="path"
        :updating="updating"
        v-if="searches.length"
      ></Searches>
      <LoadEnd v-if="loadEnd"></LoadEnd>
    <LoadError v-if="loadError && defParams.pageIndex !== 1"></LoadError>
      <loadStart v-if="fetching && defParams.pageIndex !== 1"></loadStart>
      <listSkeleton v-if="fetching && defParams.pageIndex == 1 && !searches.length" :needLoading="true" />
      <MaskLayer
        v-show="isActive"
        :isActive="isActive"
        @handlerActive="onActive"
      ></MaskLayer>
      <Nothing :addressGray="addressGray" :path="'listen'" v-if="isEmpty && !fetching"></Nothing>
      <to-top />
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import mixin from "../mixin";
  import Category from "../components/Category";
  import Searches from "../components/Searches";
  import MaskLayer from "../components/MaskLayer";
  import LoadStart from "../components/LoadStart";
  import LoadEnd from "../components/loadEnd";
import LoadError from "../components/loadError";
  import Nothing from "../components/Nothing";
  import ToTop from "../components/ToTop";
  import listSkeleton from "../components/GoodsListSkeleton";
  export default {
    name: "listen",
    mixins: [mixin],
    data() {
      return {
        path: "listen",
        name: "听书"
      };
    },
    computed: {
      ...mapState({
        category: state => state.listen.category,
        searches: state => state.listen.searches,
        fetching: state => state.listen.fetching,
        loadEnd: state => state.listen.loadEnd,
        loadError: state => state.listen.loadError,
      tabsLoading: state => state.tabsLoading,
        tabs: state => state.tabs,
        addressGray: state => state.addressGray,
      })
    },
    components: {
      Category,
      Searches,
      MaskLayer,
      LoadStart,
      LoadEnd,
    LoadError,
      Nothing,
      ToTop,
      listSkeleton,
    }
  };
  </script>
  